import { useState, useEffect, useContext } from "react";
import logo from "../../assets/images/logo-red.png";
import acade from "../../assets/images/academ.png";
import spin from "../../assets/spin.svg";
import { postDataTrace } from "../../services/trace";
import { Input, message } from "antd";
import { EyeInvisibleOutlined, EyeTwoTone } from "@ant-design/icons";
import "../../assets/css/waves.css";

import { AuthContext } from "../../contexts/AuthContext";
import { useNavigate } from "react-router";
import { Link } from "react-router-dom";
import { fetchDataTraining } from "../../services/training";

export default function Signin() {
  const { token, signin } = useContext(AuthContext);
  const [isButtonDisabled, setIsButtonDisabled] = useState(true);
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [isSpinning, setSpinning] = useState(false);

  const navigate = useNavigate();

  useEffect(() => {
    if (token) {
      navigate("/calendar");
    }
    if (email.trim() && password.trim()) {
      setIsButtonDisabled(false);
    } else {
      setIsButtonDisabled(true);
    }
  }, [email, password]);

  const handleSignin = async (e: any) => {
    setSpinning(true);
    e.preventDefault();
    const data = { username: email, password };
    const uri = `auth/login`;
    const response = await postDataTrace(data, uri);

    if (response.statusCode === 401) {
      message.error("Incorrect email or password");
      setSpinning(false);
      return;
    }
    if (response?.success) {
      await handleLocal(response);
    }

    setSpinning(false);
  };

  const handleLocal = async (data: any) => {
    const response = await fetchDataTraining({
      uri: `api/users/verify?email=${data?.user?.email}`,
    });

    if (response?.success) {
      const auth = {
        _id: response?.payload?._id,
        name: response?.payload?.name,
        mobile: response?.payload?.mobile,
        email: response?.payload?.email,
        role: response?.payload?.role,
        company: response?.payload?.company,
        accessLevel: response?.payload?.accessLevel,
      };

      const credentials = {
        user: data?.user,
        token: data?.token,
        auth: auth,
      };
      signin(credentials);
    } else {
      navigate("/denied");
    }
  };

  const handleKeyPress = (e: any) => {
    if (e.keyCode === 13 || e.which === 13) {
      isButtonDisabled || handleSignin(e);
    }
  };

  return (
    <div className="flex flex-row justify-center">
      <div
        className="p-0 md:p-4 w-0 sm:w-0 md:w-1/2 bg-gray-100 h-screen flex justify-end items-center"
        style={{ backgroundColor: "#FBF8FD" }}
      >
        <img className="mx-auto h-96 " src={acade} alt="" />
      </div>
      <div className="p-4 w-full sm:w-1/2 bg-white rounded-lg flex justify-center">
        <div className="sm:w-1/2 w-3/4 mt-32">
          <div className="text-center mt-4">
            <img className="mx-auto h-16 w-auto " src={logo} alt="" />
            <div className="text-toyota font-bold my-2 text-xs">
              TOYOTA TANZANIA
            </div>
            <div className="text-toyota font-bold my-2 text-3xl">ACADEMY</div>
            <p>Sign in with email and password </p>
          </div>
          <div className="mb-4">
            <form className="mt-8">
              <input type="hidden" name="remember" value="true" />
              <div className="rounded-md shadow-sm">
                <div>
                  <Input
                    aria-label="Email"
                    name="email"
                    type="text"
                    size="large"
                    required
                    onChange={(e) => setEmail(e.target.value)}
                    onKeyPress={(e) => handleKeyPress(e)}
                    className="flex flex-row justify-center"
                    placeholder="Email"
                  />
                </div>
                <div className="-mt-px">
                  <Input.Password
                    aria-label="Password"
                    name="password"
                    type="password"
                    size="large"
                    required
                    onChange={(e) => setPassword(e.target.value)}
                    onKeyPress={(e) => handleKeyPress(e)}
                    className="flex flex-row justify-center"
                    placeholder="Password"
                    iconRender={(visible) =>
                      visible ? <EyeTwoTone /> : <EyeInvisibleOutlined />
                    }
                  />
                </div>
              </div>

              <div className="mt-6 flex items-center justify-between">
                <div className="flex items-center">
                  <input
                    id="remember_me"
                    type="checkbox"
                    className="form-checkbox h-4 w-4 text-indigo-600 transition duration-150 ease-in-out"
                  />
                  <label className="ml-1 mr-1 block text-sm leading-5 text-gray-900">
                    Remember me
                  </label>
                </div>
                <Link
                  to="/forgot"
                  className="text-xs text-center flex items-center text-blue-900 hover:text-toyota"
                >
                  Forgot your Password?
                </Link>
              </div>

              <div className="border-t border-gray-300  max-w-md mt-4 mb-4 w-full"></div>

              <div className="mt-6 mb-4">
                <button
                  onClick={(e: any) => handleSignin(e)}
                  className="group relative w-full flex justify-center py-3 sm:py-2 px-4
                border border-transparent text-sm leading-5 font-medium
                rounded-md text-white bg-toyota hover:bg-red-700
                focus:outline-none focus:border-toyota
                focus:shadow-outline-indigo active:bg-toyota transition
                duration-150 ease-in-out"
                >
                  <span className="absolute left-0 inset-y-0 flex items-center pl-3">
                    <svg
                      className="h-5 w-5 text-white group-hover:text-whitetransition ease-in-out duration-150"
                      fill="currentColor"
                      viewBox="0 0 20 20"
                    >
                      <path
                        fillRule="evenodd"
                        d="M5 9V7a5 5 0 0110 0v2a2 2 0 012 2v5a2 2 0 01-2 2H5a2 2 0 01-2-2v-5a2 2 0 012-2zm8-2v2H7V7a3 3 0 016 0z"
                      />
                    </svg>
                  </span>
                  {isSpinning ? (
                    <span>
                      <img src={spin} alt="spin" height="20px" width="20px" />
                    </span>
                  ) : (
                    <span className="text-white">Sign in</span>
                  )}
                </button>
              </div>

              <div className="border-t border-gray-300  max-w-md mt-2 mb-4 w-full"></div>

              <div className="flex justify-center items-center text-gray-600 text-xs">
                <div className="">Don't have an account ? </div>
                <Link
                  to="/register"
                  className="text-xs text-center flex items-center font-bold text-toyota hover:text-red-800 ml-1"
                >
                  Register
                </Link>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
}
